import * as React from "react"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	register: Function
	errors: any
}
const MafoQuestionEleven: React.FC<MafoQuestionProps> = ({ register, errors }) => {
	return (
		<>
			<h3 className="mafo-headline text-left text-blue">11. Wie hast Du von der Geld-zurück-Aktion erfahren?</h3>
			<div className="mx-auto text-left lg:max-w-[100%] pt-1">
				<ElemCheckboxMafo label={<>Durch den Sticker auf der Packung</>} className=" pb-2 text-green">
					<input type="radio" {...register("question11")} name="question11" value="a" className={"peer absolute hidden h-1 w-1 " + (errors.question11 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Durch die Produkte auf dem Aufsteller/Display</>} className=" pb-2 text-green">
					<input type="radio" {...register("question11")} name="question11" value="b" className={"peer absolute hidden h-1 w-1 " + (errors.question11 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Durch Websites wie z.B. MyDealz</>} className=" pb-2 text-green">
					<input type="radio" {...register("question11")} name="question11" value="c" className={"peer absolute hidden h-1 w-1 " + (errors.question11 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Durch Social Media und Accounts, denen ich dort folge</>} className=" pb-2 text-green">
					<input type="radio" {...register("question11")} name="question11" value="d" className={"peer absolute hidden h-1 w-1 " + (errors.question11 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Durch die Mitarbeiter/innen im Supermarkt</>} className=" pb-2 text-green">
					<input type="radio" {...register("question11")} name="question11" value="e" className={"peer absolute hidden h-1 w-1 " + (errors.question11 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
			</div>
		</>
	)
}

export default MafoQuestionEleven
